// extracted by mini-css-extract-plugin
export default {"iconList":"shareWidget-module--iconList--u5sqd","socialIcon":"shareWidget-module--socialIcon--1lQbQ"};